import type * as React from 'react';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

import type { AccountTierType } from '@evenfinancial/finance-client';

export enum FeatureKey {
  dedicatedPartnerManager = 'dedicatedPartnerManager',
}

export enum ActionButtonType {
  DASHED = 'dashed',
  OUTLINED = 'outlined',
  PRIMARY = 'primary',
}
/** @deprecated */
interface DeprecatedSubscriptionPlanType {
  optionIcon?: React.FC;
}

export interface SubscriptionPlanType extends DeprecatedSubscriptionPlanType {
  actionButtonTertiary?: boolean;
  actionButtonTitle: string;
  actionButtonType?: ActionButtonType;
  cardClassName: string;
  features: Record<FeatureKey, boolean>;
  id: AccountTierType;
  integrations: {
    icon: IconProp;
    title: string;
  }[];
  isDisabled?: boolean;
  name: string;
  onActionButtonClick?: () => void;
  optionFee: string;
  optionName: string;
  planFee: string;
  pricing?: string;
  productOffersLevel: string;
  seatsNumber: string;
}
